import React, { useMemo } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useLocation, matchPath } from 'react-router-dom-latest';
import { useStorageData } from 'hooks/useStorageData';
import {
  getIsMobileRedirectDevice,
  getMobileSiteRedirect,
} from './mobile-site-redirect-utils';
import { deferredPaths } from './mobile-redirects';

export interface MobileSiteRedirectProps {
  children?: React.ReactNode;
}

export const MobileSiteRedirect = ({ children }: MobileSiteRedirectProps) => {
  const location = useLocation();
  const ldClient = useLDClient();
  const { storageData } = useStorageData();
  const {
    company_url: currentlyLoggedCpaUrl,
    cpa_uuid: currentlyLoggedCpaUuid,
  } = (storageData ?? {}) as { company_url: string; cpa_uuid?: string };
  const [redirectUrl, bypassMobileCheck] = getMobileSiteRedirect(
    window.location,
    currentlyLoggedCpaUrl,
    currentlyLoggedCpaUuid,
  );
  const isMobileRedirectDevice = getIsMobileRedirectDevice(
    window.navigator.userAgent,
  );
  const shouldDeferRendering = useMemo(
    () =>
      Boolean(
        deferredPaths.some((pattern) => matchPath(pattern, location.pathname)),
      ),
    [location],
  );

  // Handle mobile redirect; bypassMobileCheck paths redirect on every device
  if (redirectUrl && (isMobileRedirectDevice || bypassMobileCheck)) {
    window.location.replace(redirectUrl);

    // Render nothing to prevent one-time-use tokens from being consumed
    return null;
  }

  // Defer rendering until launch darkly has loaded for configured endpoints
  if (ldClient === undefined && shouldDeferRendering) {
    return null;
  }

  return (children as unknown as React.ReactElement) || null;
};
